import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ar from "@/locales/ar.json";
import en from "@/locales/en.json";

const saved = localStorage.getItem("zeeva_lang") || "ar";
i18n.use(initReactI18next).init({ resources: { ar: { translation: ar }, en: { translation: en } }, lng: saved, fallbackLng: "ar", interpolation: { escapeValue: false } });

export const applyDir = (lng) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
};
applyDir(saved);
i18n.on("languageChanged", (l) => { localStorage.setItem("zeeva_lang", l); applyDir(l); });
export default i18n;
